export const cubicBezierCurve = 'cubic-bezier(.25,.1,.25,1)';
